export default {
      id: "ic-misc-translate-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-translate-usage",
      toString: function () {
        return this.url;
      }
    }